export default __webpack_public_path__ + "static/media/phones-color.11e1ebb0.svg";